import { lazy } from '../../shared/deployment';

// eslint-disable-next-line import/prefer-default-export
export const CertificateDownloadButton = lazy(() => import('./CertificateDownloadButton'));
export const CertificateList = lazy(() => import('./certificateList/CertificateList'));
